import api from '../services/api';

const PRODUCTS_V2_URL = '/products/v2'

export default {
    search,
};

function search (params) {
    return api({
        url: PRODUCTS_V2_URL,
        method: 'GET',
        params: params,
    });
}
